import api from "../../api";
import axios from "../../utils/axios.instance";
import handleError from "../handle-error";

interface IPagination {
    page: number
    limit: number
}


export const getHiringCompanyMembers = async ({ page, limit }: IPagination = {
    page: 1,
    limit: 10
}) => {
    try {
        const params = new URLSearchParams();
        if (page !== undefined) params.append("page", page.toString());
        if (limit !== undefined) params.append("limit", limit.toString());

        const url = params.toString()
            ? `${api.hiringCompanyMembers}?${params.toString()}`
            : api.hiringCompanyMembers;
        const { data } = await axios.get(url);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};

export const inviteHiringStaff = async (payload) => {
    try {
        const { data } = await axios.post(api.inviteHiringStaff, payload);
        return data;
    } catch (err) {
        throw handleError(err);
    }
};

export const getHiringCompanyInvitationDetails = async (token: string) => {
    try {
        const { data } = await axios.get(api.hiringCompanyInvitationDetails(token));
        return data;
    } catch (err) {
        throw handleError(err);
    }
};
